function sanitizeJsonString(jsonString, double_back=true) {
    // Escape unescaped single quotes
    
    if (double_back) {
        jsonString = jsonString.replace(/(?<!\\)'/g, "\\'");
    } else {
        jsonString = jsonString.replace(/(?<!\\)'/g, "\'");
    }

    jsonString = jsonString.replace(/\\\//g, '/');

    // ✂Strip any paragraph symbols (¶, U+00B6)
    // jsonString = jsonString.replace(/\u00B6/g, "");
    
    // Ensure keys are enclosed in double quotes
    jsonString = jsonString.replace(/(?<=[{,])\s*([a-zA-Z0-9_]+)\s*:/g, '"$1":');
    
    // Remove trailing commas
    jsonString = jsonString.replace(/,\s*([}\]])/g, '$1');
    
    return jsonString;
}

export default sanitizeJsonString